import type React from 'react'

import css from './styles.module.css'

export const PlanCardSkeleton: React.FC = () => {
  return (
    <div className={css.plan_card_skeleton}>
      <div className={css.header}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
      <div className={css.messages}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
      <div className={css.links}>
        <div data-skeleton-animation />
        <div data-skeleton-animation />
      </div>
    </div>
  )
}
